















import { Vue, Component } from "vue-property-decorator";
import { DocTemplate as IDocTemplate } from "@/api/models/doc-template";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs }
})
export default class DocTemplateEdit extends Vue {
  template!: IDocTemplate;

  data() {
    return {
      template: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "docTemplates" },
        label: `${this.$tc(this.$translate.DocumentTemplates)}`
      },
      {
        label: this.$converter.limitedOutput(this.template.title, 40)
      }
    ];
  }

  // created() {
  //   api.DocTemplateApi.get(this.$route.params.id).then(
  //     (res: { data: IDocTemplate }) => {
  //       this.template = res.data;
  //     }
  //   );
  // }
}
